module.exports = __webpack_public_path__ + "static/img/temp-pc-contents04@m.79ac1be.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/ezn-foundation/temp-pc-contents04@m.jpg
// module id = bP+1
// module chunks = 0